export default {"mainContainer":"PB0eb","leftContainer":"i4yTb","leftContainerImage":"j27Sc","assessmentText":"rUBU7","rightContainer":"ahSxX"};